<card-expanding
  [formGroup]="form"
  [valid]="productValidity.getCardStatusValidType(cardSection)"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <span header-title>{{ title | translate}}</span>

  <div header-actions>
    <ng-container *ngIf="isOwnProduct">
      <locked-info *ngIf="!edit && locked" [locked]="locked"></locked-info>
      <ng-container
        *ngIf="!edit && !locked"
      >
        <ng-container *requiredRights="[UserAction.ManageProducts]">
          <lxm-button
            *ngIf="productId"
            type="beige"
            icon="edit"
            title="action.edit"
            (click)="toggleEdit()"
          ></lxm-button>
        </ng-container>
      </ng-container>

      <ng-container
        class="align-center flex flex-wrap justify-end"
        *ngIf="edit && productId"
      >
        <lxm-button
          type="grey"
          icon="back"
          label="action.cancel"
          (click)="cancelEdit()"
        ></lxm-button>
        <lxm-button
          type="beige"
          icon="save"
          label="action.save"
          [loading]="saveLoading"
          (click)="save()"
          buttonType="submit"
        ></lxm-button>
      </ng-container>

      <div class="align-center flex flex-wrap justify-end" *ngIf="!productId">
        <lxm-button
          class="ml15"
          type="grey"
          icon="back"
          label="action.cancel"
          (click)="backToList()"
        ></lxm-button>
        <lxm-button
          class="card-header-button ml15"
          type="beige"
          icon="save"
          label="action.save"
          [loading]="createLoading"
          (click)="create()"
          buttonType="submit"
        ></lxm-button>
      </div>
    </ng-container>
  </div>

  <div body>
    <card-section>
      <div class="grid w-full grid-cols-1 gap-4 xl:grid-cols-2">
        <div class="flex flex-col">
          <form-field
            [readonly]="!edit"
            labelTop="true"
            label="cards.products.product_base_info.label.full_name"
            description="cards.products.product_base_info.label_description.full_name"
            for="fullName"
            [required]="edit"
            [validationResultType]="productValidity.isRequiredByRetailerLanguageText(productField.FullName)"
          >
            <language-text
              language-text
              for="fullName"
              [validationResultType]="productValidity.getLanguageTextRequiredTypes(productField.FullName)"
              [readonly]="!edit"
              newline="true"
              maxlength="200"
            >
            </language-text>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.brand"
            description="cards.products.product_base_info.label_description.brand"
            for="brand"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Brand, form.get('brand').value)"
          >
            <lxm-select
              select
              [readonly]="!edit"
              labelField="value"
              [searchable]="true"
              for="brand"
              [options]="productBrands"
            >
              <lxm-button
                *requiredRights="[UserAction.ManageClvs]"
                header
                label="action.add_new"
                icon="plus-dark"
                (click)="openClassificatorValueDialog(ClvType.ProductBrand, form.get('brand'), 'productBrands')"
              >
              </lxm-button>
            </lxm-select>
            <validation-errors for="brand"></validation-errors>
            <validation-errors for="brandId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.subbrand"
            description="cards.products.product_base_info.label_description.subbrand"
            for="subBrand"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SubBrand, form.get('subBrand').value)"
          >
            <lxm-select
              select
              [readonly]="!edit"
              labelField="value"
              [searchable]="true"
              for="subBrand"
              [options]="productSubBrands"
            >
              <lxm-button
                *requiredRights="[UserAction.ManageClvs]"
                header
                label="action.add_new"
                icon="plus-dark"
                (click)="openClassificatorValueDialog(ClvType.ProductBrand, form.get('subBrand'), 'productSubBrands')"
              >
              </lxm-button>
            </lxm-select>
            <validation-errors for="subBrand"></validation-errors>
            <validation-errors for="subBrandId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.model"
            description="cards.products.product_base_info.label_description.model"
            for="model"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Model, form.get('model').value)"
          >
            <validation-errors for="model"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.color"
            description="cards.products.product_base_info.label_description.color"
            for="color"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Color, form.get('color').value)"
          >
            <validation-errors for="color"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.origin"
            description="cards.products.product_base_info.label_description.origin"
            for="countryOfOrigin"
            [required]="edit"
          >
            <lxm-select
              select
              [readonly]="!edit"
              [options]="countryOptions"
              [isTranslated]="true"
              labelField="translatedName"
              [sortByLabel]="true"
              [searchable]="true"
              labelIconField="iso3"
              labelIconFallback="global"
              labelIconClass="flag-icon"
              for="countryOfOrigin"
            >
            </lxm-select>
            <validation-errors for="countryOfOrigin"></validation-errors>
            <validation-errors for="countryOfOriginId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.additional_origin"
            description="cards.products.product_base_info.label_description.additional_origin"
            for="additionalCountryOfOrigin"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.AdditionalCountryOfOrigin, form.get('additionalCountryOfOrigin').value)"
          >
            <lxm-select
              select
              [readonly]="!edit"
              [options]="countryOptions"
              [isTranslated]="true"
              labelField="translatedName"
              [sortByLabel]="true"
              [searchable]="true"
              labelIconField="iso3"
              labelIconFallback="global"
              labelIconClass="flag-icon"
              for="additionalCountryOfOrigin"
            >
            </lxm-select>
            <validation-errors for="additionalCountryOfOrigin"></validation-errors>
            <validation-errors for="additionalCountryOfOriginId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.country_of_production"
            description="cards.products.product_base_info.label_description.country_of_production"
            for="countryOfProduction"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.CountryOfProduction, form.get('countryOfProduction').value)"
          >
            <lxm-select
              select
              [readonly]="!edit"
              [options]="countryOptions"
              [isTranslated]="true"
              labelField="translatedName"
              [sortByLabel]="true"
              [searchable]="true"
              labelIconField="iso3"
              labelIconFallback="global"
              labelIconClass="flag-icon"
              for="countryOfProduction"
            >
            </lxm-select>
            <validation-errors for="countryOfProduction"></validation-errors>
            <validation-errors for="countryOfProductionId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.country_of_packaging"
            description="cards.products.product_base_info.label_description.country_of_packaging"
            for="countryOfPackaging"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.CountryOfPackaging, form.get('countryOfPackaging').value)"
          >
            <lxm-select
              select
              [readonly]="!edit"
              [options]="countryOptions"
              [isTranslated]="true"
              labelField="translatedName"
              [sortByLabel]="true"
              [searchable]="true"
              labelIconField="iso3"
              labelIconFallback="global"
              labelIconClass="flag-icon"
              for="countryOfPackaging"
            >
            </lxm-select>
            <validation-errors for="countryOfPackaging"></validation-errors>
            <validation-errors for="countryOfPackagingId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.manufacturer"
            description="cards.products.product_base_info.label_description.manufacturer"
            for="manufacturer"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Manufacturer, form.get('manufacturer').value)"
          >
            <lxm-select
              select
              [readonly]="!edit"
              labelField="value"
              [searchable]="true"
              for="manufacturer"
              [options]="productManufacturers"
            >
              <lxm-button
                *requiredRights="[UserAction.ManageClvs]"
                header
                label="action.add_new"
                icon="plus-dark"
                (click)="openClassificatorValueDialog(ClvType.Manufacturer, form.get('manufacturer'), 'productManufacturers')"
              >
              </lxm-button>
            </lxm-select>
            <div
              below
              class="alt-text input-padding"
              *ngIf="form.get('manufacturer').value"
            >
              {{ form.get('manufacturer').value.address | address }} <br />
              {{ form.get('manufacturer').value.gln }}
            </div>
            <validation-errors for="manufacturer"></validation-errors>
            <validation-errors for="manufacturerId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.additional_manufacturers"
            description="cards.products.product_base_info.label_description.additional_manufacturers"
            for="additionalManufacturers"
          >
            <lxm-select
              select
              [readonly]="!edit"
              labelField="value"
              [searchable]="true"
              [multiple]="true"
              compareField="id"
              for="additionalManufacturers"
              [options]="productManufacturers"
            >
              <lxm-button
                *requiredRights="[UserAction.ManageClvs]"
                header
                label="action.add_new"
                icon="plus-dark"
                (click)="openClassificatorValueDialog(ClvType.Manufacturer, form.get('additionalManufacturers'), 'productManufacturers', true)"
              >
              </lxm-button>
            </lxm-select>
            <validation-errors for="additionalManufacturers"></validation-errors>
            <validation-errors for="additionalManufacturerIds"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.importer"
            description="cards.products.product_base_info.label_description.importer"
            for="importer"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Importer, form.get('importer').value)"
          >
            <lxm-select
              select
              [readonly]="!edit"
              labelField="value"
              [searchable]="true"
              for="importer"
              [options]="productManufacturers"
            >
              <lxm-button
                *requiredRights="[UserAction.ManageClvs]"
                header
                label="action.add_new"
                icon="plus-dark"
                (click)="openClassificatorValueDialog(ClvType.Manufacturer, form.get('importer'), 'productManufacturers')"
              >
              </lxm-button>
            </lxm-select>
            <div
              below
              class="alt-text input-padding"
              *ngIf="form.get('importer').value"
            >
              {{ form.get('importer').value.address | address }} <br />
              {{ form.get('importer').value.gln }}
            </div>
            <validation-errors for="importer"></validation-errors>
            <validation-errors for="importerId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.additional_importers"
            description="cards.products.product_base_info.label_description.additional_importers"
            for="additionalImporters"
          >
            <lxm-select
              select
              [readonly]="!edit"
              labelField="value"
              [searchable]="true"
              [multiple]="true"
              compareField="id"
              for="additionalImporters"
              [options]="productManufacturers"
            >
              <lxm-button
                *requiredRights="[UserAction.ManageClvs]"
                header
                label="action.add_new"
                icon="plus-dark"
                (click)="openClassificatorValueDialog(ClvType.Manufacturer, form.get('additionalImporters'), 'productManufacturers', true)"
              >
              </lxm-button>
            </lxm-select>
            <validation-errors for="additionalImporters"></validation-errors>
            <validation-errors for="additionalImporterIds"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.consignment"
            description="cards.products.product_base_info.label_description.consignment"
          >
            <slide-toggle
              toggle
              for="isConsignmentProduct"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="isConsignmentProduct"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.customs_code"
            description="cards.products.product_base_info.label_description.customs_code"
            for="customsCode"
            [inputWidth]="null"
            type="input-text"
            [required]="(edit && form.get('isEudrProduct').value)" [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.CustomsCode, form.get('customsCode').value)"
          >
            <div class="eudr-icon" after *ngIf="isEudrProduct"></div>
            <div
              below
              class="alt-text input-padding"
              *ngIf="isEudrProduct"
            >
              {{ 'cards.products.product_base_info.eudr_hint' | translate }}
            </div>
            <validation-errors for="customsCode"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.is_eudr_product"
            description="cards.products.product_base_info.label_description.is_eudr_product"
          >
            <slide-toggle
              toggle
              for="isEudrProduct"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="isEudrProduct"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.excise_certificate"
            description="cards.products.product_base_info.label_description.excise_certificate"
          >
            <slide-toggle
              toggle
              for="hasExciseCertificate"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="hasExciseCertificate"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.has_lot_number"
            description="cards.products.product_base_info.label_description.has_lot_number"
          >
            <slide-toggle
              toggle
              for="hasLotNumber"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="hasLotNumber"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.hygiene_certificate_required"
            description="cards.products.product_base_info.label_description.hygiene_certificate_required"
          >
            <slide-toggle
              toggle
              for="hygieneCertificateRequired"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors
              for="hygieneCertificateRequired"
            ></validation-errors>
          </form-field>
        </div>

        <div class="flex flex-col">
          <form-field
            [readonly]="!edit"
            labelTop="true"
            label="cards.products.product_base_info.label.short_name"
            description="cards.products.product_base_info.label_description.short_name"
            for="shortName"
            [validationResultType]="productValidity.isRequiredByRetailerLanguageText(productField.ShortName)"
          >
            <language-text
              language-text
              for="shortName"
              [readonly]="!edit"
              newline="true"
              maxlength="40"
              [validationResultType]="productValidity.getLanguageTextRequiredTypes(productField.ShortName)"
            ></language-text>
          </form-field>

          <form-field
            *ngIf="appState.hasModule(LxmAppModule.WarehouseTypes)"
            [readonly]="!edit"
            label="cards.products.product_base_info.label.warehouse_type"
            description="cards.products.product_base_info.label_description.warehouse_type"
            for="warehouseTypeId"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.WarehouseType, form.get('warehouseTypeId').value)"
          >
            <lxm-select
              select
              [readonly]="!edit"
              labelField="value"
              [searchable]="true"
              for="warehouseTypeId"
              value="id"
              [options]="warehouseTypes"
              [labelFn]="warehouseTypeLabel"
            >
            </lxm-select>
            <validation-errors for="warehouseTypeId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.unit_order"
            description="cards.products.product_base_info.label_description.unit_order"
            for="orderUnitId"
            [required]="edit" [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.OrderUnit, form.get('orderUnitId').value)"
          >
            <lxm-select
              select
              [options]="units"
              for="orderUnitId"
              value="id"
              [readonly]="!edit"
              labelField="translatedValue"
              [isTranslated]="true"
            ></lxm-select>
            <validation-errors for="orderUnitId"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.unit_sales"
            description="cards.products.product_base_info.label_description.unit_sales"
            for="salesUnitId"
            [required]="edit" [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.SalesUnit, form.get('salesUnitId').value)"
          >
            <lxm-select
              select
              [options]="units"
              for="salesUnitId"
              [readonly]="!edit"
              value="id"
              labelField="translatedValue"
              [isTranslated]="true"
            ></lxm-select>
            <validation-errors for="salesUnitId"></validation-errors>
          </form-field>

          <!-- only required for unit type kg -->
          <form-field
            *ngIf="form.get('salesUnitId').value === unitKg"
            [readonly]="!edit"
            label="cards.products.product_base_info.label.content_avg"
            description="cards.products.product_base_info.label_description.content_avg"
            for="averageWeightInGrams"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.AverageWeightInGrams, form.get('averageWeightInGrams').value)"
          >
            <validation-errors for="averageWeightInGrams"></validation-errors>
          </form-field>

          <form-field
            *ngIf="form.get('salesUnitId').value === unitKg"
            [readonly]="!edit"
            label="cards.products.product_base_info.label.marking_price_required"
            description="cards.products.product_base_info.label_description.marking_price_required"
          >
            <slide-toggle
              toggle
              for="markingPriceRequired"
              [readonly]="!edit"
            ></slide-toggle>
            <validation-errors for="markingPriceRequired"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.content_net"
            description="cards.products.product_base_info.label_description.content_net"
            for="netContent"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.NetContent, form.get('netContent').value)"
          >
            <validation-errors for="netContent"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.content_unit"
            description="cards.products.product_base_info.label_description.content_unit"
            for="contentUnitId"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ContentUnit, form.get('contentUnitId').value)"
          >
            <lxm-select
              select
              [options]="units"
              for="contentUnitId"
              [readonly]="!edit"
              value="id"
              labelField="translatedValue"
              [isTranslated]="true"
            ></lxm-select>
            <validation-errors for="contentUnitId"></validation-errors>
          </form-field>

          <form-field
            *ngIf="drainedWeightEnabled"
            [readonly]="!edit"
            label="cards.products.product_base_info.label.content_drained"
            description="cards.products.product_base_info.label_description.content_drained"
            for="drainedWeightInGrams"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.DrainedWeightInKg, form.get('drainedWeightInGrams').value)"
          >
            <validation-errors for="drainedWeightInGrams"></validation-errors>
          </form-field>

          <form-field
            *ngIf="bakedWeightEnabled"
            [readonly]="!edit"
            label="cards.products.product_base_info.label.content_baked"
            description="cards.products.product_base_info.label_description.content_baked"
            for="bakedWeightInGrams"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.BakedWeightInGrams, form.get('bakedWeightInGrams').value)"
          >
            <validation-errors for="bakedWeightInGrams"></validation-errors>
          </form-field>

          <form-field
            *ngIf="sizeInfoEnabled"
            [readonly]="!edit"
            label="cards.products.product_base_info.label.size_info"
            description="cards.products.product_base_info.label_description.size_info"
            for="additionalSizeInfo"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.AdditionalSizeInfo, form.get('additionalSizeInfo').value)"
          >
            <validation-errors for="additionalSizeInfo"></validation-errors>
          </form-field>

          <form-field
            *ngIf="servingSizeEnabled"
            [readonly]="!edit"
            label="cards.products.product_base_info.label.serving_size"
            description="cards.products.product_base_info.label_description.serving_size"
            for="servingSizeInGrams"
            type="input-text"
            [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.ServingSizeInGrams, form.get('servingSizeInGrams').value)"
          >
            <validation-errors for="servingSizeInGrams"></validation-errors>
          </form-field>

          <form-field
            [readonly]="!edit"
            label="cards.products.product_base_info.label.segment_gs1"
            description="cards.products.product_base_info.label_description.segment_gs1"
            for="gs1Segment"
            [required]="edit"
          >
            <lxm-select
              select
              [readonly]="!edit"
              [searchable]="true"
              labelField="title"
              for="gs1Segment"
              url="api/clvac/product-level-gs1-segments/"
            >
            </lxm-select>
            <!-- <validation-errors for="gs1Segment"></validation-errors> -->
            <validation-errors
              for="gs1SegmentId"
              aliasTo="gs1Segment"
            ></validation-errors>
          </form-field>

          <!-- <form-field [readonly]="!edit" label="cards.products.product_base_info.label.segment" *requiredSupplier
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.Segment, form.get('segment').value)">
          <lxm-select select [readonly]="!edit" [searchable]="true" labelField="title" for="segment"
            url="api/clvac/productlevelsegments/">
          </lxm-select>
          <validation-errors for="segment"></validation-errors>
          <validation-errors for="segmentId"></validation-errors>
        </form-field> -->

          <ng-container *ngIf="isOwnProduct">
            <form-field
              [readonly]="!edit"
              label="cards.products.product_base_info.label.segment"
              description="cards.products.product_base_info.label_description.segment"
              for="segment"
            >
              <lxm-select
                select
                [readonly]="!edit"
                [searchable]="true"
                labelField="title"
                for="segment"
                [options]="segmentOptions"
              >
              </lxm-select>
              <validation-errors for="segment"></validation-errors>
              <validation-errors for="segmentId"></validation-errors>
            </form-field>

            <form-field
              [readonly]="!edit"
              *ngIf="showOtherSegments"
              for="segmentOther"
            >
              <lxm-select
                select
                [readonly]="!edit"
                [searchable]="true"
                for="segmentOther"
                [options]="segmentOtherOptions"
                [disableOption]="disableOption"
                [labelFn]="segmentTreeLabel"
              >
              </lxm-select>
            </form-field>
          </ng-container>

          <ng-container
            *ngIf="appState.hasModule(LxmAppModule.SendOffers) && isOwnProduct"
          >
            <form-field
              *ngIf="activeAssortmentPeriod || activeOffers?.length > 0"
              label="cards.products.product_base_info.label.product_status"
              description="cards.products.product_base_info.label_description.product_status"
              [readonly]="!edit"
            >
              <div any class="product-status input-padding">
                <span
                  *ngIf="activeAssortmentPeriod?.validFrom"
                  class="pb4"
                  class="assortment-period"
                >
                  {{ activeAssortmentPeriod.validTo ?
                  (('cards.products.product_base_info.in_assortment_until' |
                  translate) + (activeAssortmentPeriod.validTo | formDate) ) :
                  ('cards.products.product_base_info.in_assortment_termless' |
                  translate) }}
                </span>
                <ng-container
                  *requiredRights="[UserAction.ViewSupplierOffers, UserAction.ViewOthersSupplierOffers]"
                >
                  <a
                    class="active-offer link"
                    *ngFor="let offer of activeOffers | slice:0:activeOffersRenderCount"
                    href="offers/{{offer.offerId}}"
                    target="_blank"
                  >
                    {{ offer.activeTo ?
                    (('cards.products.product_base_info.in_active_offer_until' |
                    translate) + (offer.activeTo | formDate) ) :
                    ('cards.products.product_base_info.in_active_offer_termless'
                    | translate) }}
                  </a>
                  <span
                    class="list-overflow-count"
                    *ngIf="activeOffers?.length > activeOffersRenderBaseCount"
                    (click)="toggleAllActiveOffers()"
                    [class.show-less]="activeOffersRenderCount > activeOffersRenderBaseCount"
                  >
                    {{ activeOffersRenderCount > activeOffersRenderBaseCount ?
                    '-' : '+' }} ({{activeOffers.length -
                    activeOffersRenderBaseCount}})
                  </span>
                </ng-container>
              </div>
            </form-field>
          </ng-container>
        </div>
      </div>
    </card-section>

    <div class="separator"></div>

    <card-section>
      <span header-title
        >{{'cards.products.product_base_info.codes.title' | translate}}</span
      >

      <div body class="flex flex-col">
        <product-code-manager
          for="codes"
          [readonly]="!edit"
          [codeTypes]="codeTypes"
          startIndex="{{productId ? 1 : 0}}"
        >
        </product-code-manager>

        <card-message
          class="mt10"
          type="error"
          message="cards.products.product_base_info.codes.no_codes_error"
          *ngIf="productValidity.shouldValidate ? productValidity.isRequiredByRetailer(cardSection, productField.BaseUnitCodes, form.get('codes').value?.length > 1) : false"
        >
        </card-message>
      </div>
    </card-section>
  </div>
</card-expanding>
